const products = () => {

  // eslint-disable-next-line no-undef
  const isProd = process.env.REACT_APP_CPHILL_ENV === 'production'
  
  return [
    // Full
    {
      type: 'pass',
      id: 'passAnnualAdultFull',
      skuId: isProd ? 'sku_DtQdL5biF6t0OD' : 'sku_DhqO0vzyms9A41',
      defaultName: 'Annual pass',
      ageCategory: 'adult',
      hourRateWeekdaysSkuId: isProd ? 'sku_DtQsKgqhEUsfoO' : 'sku_DiER2sNwFJsG84',
      hourRateWeekendsSkuId: isProd ? 'sku_DtQqDunsVm5CAv' : 'sku_DiGC4svb518Ywl',
      giftcardSkuId: isProd ? 'sku_DtPmcQo7dbYKTH' : 'sku_DlyRIAp7vgvIqz',
      renewalSkuId: isProd ? 'sku_IqaMiwKob6T6um' : 'sku_Ia6P6LFtqId9Oc'
    }, 
    {
      type: 'pass',
      id: 'passAnnualChildFull',
      skuId: isProd ? 'sku_DtQduAaCLi7Q8r' : 'sku_Dhr6SlKJ3sHNYg',
      defaultName: 'Annual pass',
      ageCategory: 'child',
      hourRateWeekdaysSkuId: isProd ? 'sku_DtQsdpace171q9' : 'sku_DiES4t5QG9DBWN',
      hourRateWeekendsSkuId: isProd ? 'sku_DtQrCGVfayGB6e' : 'sku_DiGCQvpelLZC6u',
      giftcardSkuId: isProd ? 'sku_DtPlh1Y6o9PNit' : 'sku_DntqPNYj0S9AlN',
      renewalSkuId: isProd ? 'sku_IqaMHRJl1FxG25' : 'sku_Ia6PEyuGGxVtEO'
    },
    // Weekdays
    {
      type: 'pass',
      id: 'passAnnualAdultWeekdays',
      skuId: isProd ? 'sku_DtQgg0ZoPoAGNI' : 'passAnnualAdultWeekdays',
      defaultName: 'Annual pass - weekdays',
      ageCategory: 'adult',
      hourRateWeekdaysSkuId: isProd ? 'sku_DtQuatO2IyW5R7' : 'sku_DiW6gTa1CZPyYU',
      hourRateWeekendsSkuId: isProd ? 'sku_DtQvDWV6651dN7' : 'sku_DiW6tm7B3JiHqj',
      giftcardSkuId: isProd ? 'sku_DtPiLOENeJjQGj' : 'sku_DnttgKYI7QO0RL',
      renewalSkuId: isProd ? 'sku_IqaHmUszCHRYVb' : 'sku_Ia72gisdOJhXTP'
    },
    {
      type: 'pass',
      id: 'passAnnualChildWeekdays',
      skuId: isProd ? 'sku_DtQfGtblMzFIAz' : 'passAnnualChildWeekdays',
      defaultName: 'Annual pass - weekdays',
      ageCategory: 'child',
      hourRateWeekdaysSkuId: isProd ? 'sku_DtQw5Tzs1Z4Lpn' : 'sku_DiW6s3igrRvam9',
      hourRateWeekendsSkuId: isProd ? 'sku_DtQuYHzuzXf4yu' : 'sku_DiW6fZEFrKNpJs',
      giftcardSkuId: isProd ? 'sku_DtPjAPb3poBaft' : 'sku_Dnts3qFlqXvJTv',
      renewalSkuId: isProd ? 'sku_IqaHcAHozHm82s' : 'sku_Ia72Cq8vo8tBqu'
    },
    // Advantage
    {
      type: 'pass',
      id: 'passAnnualAdultAdvantage',
      skuId: isProd ? 'sku_DtQj6GE0AXmZ82' : 'sku_DiWFKpID2wfHgn',
      defaultName: 'Annual advantage pass',
      ageCategory: 'adult',
      hourRateWeekdaysSkuId: isProd ? 'sku_DtR1WHOHmahUjh' : 'sku_DiWK3nbv15PexT',
      hourRateWeekendsSkuId: isProd ? 'sku_DtR1B6015ANEQP' : 'sku_DiWLDUNAlP6JPF',
      giftcardSkuId: isProd ? 'sku_DtPg4fL0gD8ah6' : 'sku_DntvprQ9XwRxAD',
      renewalSkuId: isProd ? 'sku_IX9wIQYw7w7SDy' : 'sku_IX9woHWkZQysoL'
    },
    {
      type: 'pass',
      id: 'passAnnualChildAdvantage',
      skuId: isProd ? 'sku_DtQiDOKN9U66Vs' : 'sku_DiWFgmAxI23UxK',
      defaultName: 'Annual advantage pass',
      ageCategory: 'child',
      hourRateWeekdaysSkuId: isProd ? 'sku_DtR0ZyLjAmNHvM' : 'sku_DiWLZiswhCF9Zd',
      hourRateWeekendsSkuId: isProd ? 'sku_DtQz9uJoz9k56o' : 'sku_DiWLRBBNHANnGq',
      giftcardSkuId: isProd ? 'sku_DtPeDOdKh1ueoG' : 'sku_DntwJh9R3Vu6KW',
      renewalSkuId: isProd ? 'sku_IX9woHWkZQysoL' : 'sku_IX9wIQYw7w7SDy'
    },
    // Hourly
    {
      type: 'pass',
      id: 'passHourlyAdult',
      skuId: isProd ? 'sku_DtQm44VC6soGKm' : 'sku_DiWYicifdianNh',
      defaultName: 'Hourly pass',
      ageCategory: 'adult',
      hourRateWeekdaysSkuId: isProd ? 'sku_DtRLhcDJzYyAWn' : 'sku_DiWax72Ak2smZL',
      hourRateWeekendsSkuId: isProd ? 'sku_DtRLEWNyWw2ift' : 'sku_DiWamBQzbMujAM'
    },
    {
      type: 'pass',
      id: 'passHourlyChild',
      skuId: isProd ? 'sku_DtQm0F0FV9yGXQ' : 'sku_DiWYAa7ui4se6J',
      defaultName: 'Hourly pass',
      ageCategory: 'child',
      hourRateWeekdaysSkuId: isProd ? 'sku_DtRN0SWAhv4y1t' : 'sku_DiWZNM5yPMG7vb',
      hourRateWeekendsSkuId: isProd ? 'sku_DtRMXYtu9uOFAc' : 'sku_DiWav2kiJtT7kf'
    },
    // Insurances
    {
      type: 'other',
      id: 'insurance',
      mandatoryDailySkuId: isProd ? 'sku_DtQQ2VgStt3FRB' : 'sku_DkUjhdSKjfnQUs',
      mandatoryYearlySkuId: isProd ? 'sku_DtQP8H5IFpA0Ue' : 'sku_DlEMIBZmF7e9lC',
      cancellationSkuId: isProd ? 'sku_DtQQeyiosFqMKB' : 'sku_DkUkMXHQddYwLS',
      rentalSkuId: isProd ? 'sku_DtQPPpeQ5wlv0V' : 'sku_DkUkjrGK74HITJ'
    },
    // Instruction
    {
      type: 'other',
      id: 'instruction',
      stripeProductId: isProd ? 'prod_ET4V9WyfsuqDG9' : 'prod_EQkbwpgqZg6GOQ', 
      hourStandardSkuId: isProd ? 'sku_ET4WegATcLRFih' : 'sku_EQkcyZWiEIxMLG',
    },
    // Rental equipment
    {
      type: 'other',
      id: 'rental',
      hourSkisAdultStandard: isProd ? 'sku_ET4ZZUv1y0r3Ab' : 'sku_ERp8GsG9NEFHSR',
      hourSkisChildStandard: isProd ? 'sku_ET4YvgV7rPpYld' : 'sku_ERpGklVHEXRvAC',
      hourBootsAdultStandard: isProd ? 'sku_ET4YzDOiXRCoxU' : 'sku_ERpAPCP7eMPZGS',
      hourBootsChildStandard: isProd ? 'sku_ET4YPuXNgGr5YZ' : 'sku_ERpFF8epAYsvLz',
      hourHelmetAdultStandard: isProd ? 'sku_ET4XOlxNQBWWtr' : 'sku_ERpjv14KImWfrh',
      hourHelmetChildStandard: isProd ? 'sku_ET4XoyvYdjkUne' : 'sku_ERpiCMtyTrXMkT'      
    },
    // Misc
    {
      type: 'other',
      id: 'misc',
      replacementCardSkuId: isProd ? 'sku_JVTykoMVvJWFTw' : 'sku_JVUWjRdFeQRocL'
    },
    // Bulk
    // {
    //   type: 'bulk',
    //   id: 'comboSkiHours3Adult',
    //   ageCategory: 'adult',
    //   skuId: isProd ? 'sku_E1hj8ukSgaqeEj' : 'sku_E1bvsDLWRefX0I',
    //   defaultName: '3 hours skitime',
    //   giftcardSkuId: isProd ? 'sku_E1hmpkJzqtuftP' : 'sku_E1eeJ7NKbozCYc'
    // },
    // {
    //   type: 'bulk',
    //   id: 'comboSkiHours3Child',
    //   ageCategory: 'child',
    //   skuId: isProd ? 'sku_E3uQr6K886s9fZ' : 'sku_E3tOMSmSjHfhk2',
    //   defaultName: '3 hours skitime',
    //   giftcardSkuId: isProd ? 'sku_E3uS8otRNILKll' : 'sku_E3tPjGFwSDbaEf'
    // },
    {
      type: 'bulk',
      id: '1HourHillAdult',
      ageCategory: 'adult',
      skuId: isProd ? 'sku_GGgysmkxjrBX5D' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGgysmkxjrBX5D' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '2HourHillAdult',
      ageCategory: 'adult',
      skuId: isProd ? 'sku_GGhHgO5N6jz9aA' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhHgO5N6jz9aA' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '3HourHillAdult',
      ageCategory: 'adult',
      skuId: isProd ? 'sku_GGhIj8WR0gl1Ut' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhIj8WR0gl1Ut' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '1HourHillPlusGearAdult',
      ageCategory: 'adult',
      skuId: isProd ? 'sku_GGhJvQ1Yi3npIK' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhJvQ1Yi3npIK' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '2HourHillPlusGearAdult',
      ageCategory: 'adult',
      skuId: isProd ? 'sku_GGhJY3haqtGtWG' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhJY3haqtGtWG' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '3HourHillPlusGearAdult',
      ageCategory: 'adult',
      skuId: isProd ? 'sku_GGhOX7aQYm6y1n' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhOX7aQYm6y1n' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '1HourHillChild',
      ageCategory: 'child',
      skuId: isProd ? 'sku_GGhHvzr2vlSOgu' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhHvzr2vlSOgu' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '2HourHillChild',
      ageCategory: 'child',
      skuId: isProd ? 'sku_GGhIEwcpkiZC2I' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhIEwcpkiZC2I' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '3HourHillChild',
      ageCategory: 'child',
      skuId: isProd ? 'sku_GGhISWnUWc1wyB' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhISWnUWc1wyB' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '1HourHillPlusGearChild',
      ageCategory: 'child',
      skuId: isProd ? 'sku_GGhJUdwBXyHlAm' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhJUdwBXyHlAm' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '2HourHillPlusGearChild',
      ageCategory: 'child',
      skuId: isProd ? 'sku_GGhKptwswqT8e0' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhKptwswqT8e0' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'bulk',
      id: '3HourHillPlusGearChild',
      ageCategory: 'child',
      skuId: isProd ? 'sku_GGhPPOhTsvhNYD' : 'sku_E4FitLXaqIPzYw',
      defaultName: 'Bulk',
      giftcardSkuId: isProd ? 'sku_GGhPPOhTsvhNYD' : 'sku_E4Fj6ftjLgnE1G'
    },    

    // Combos2pax
    {
      type: 'combo2pax',
      id: 'combo1hourInclEquip2pax',
      skuId: isProd ? 'sku_GN1ndGX6hSJIFU' : 'sku_E4Fj6ftjLgnE1G',
      defaultName: '',
      giftcardSkuId: isProd ? 'sku_GN1ndGX6hSJIFU' : 'sku_E4Fj6ftjLgnE1G'      
    },
    {
      type: 'combo2pax',
      id: 'combo2hourInclEquip2pax',
      skuId: isProd ? 'sku_GN1oHnJQRNhktO' : 'sku_E4Fj6ftjLgnE1G',
      defaultName: '',
      giftcardSkuId: isProd ? 'sku_GN1oHnJQRNhktO' : 'sku_E4Fj6ftjLgnE1G'      
    },
    {
      type: 'combo2pax',
      id: 'combo3hourInclEquip2pax',
      skuId: isProd ? 'sku_GN1ogVZOkA5gxv' : 'sku_E4Fj6ftjLgnE1G',
      defaultName: '',
      giftcardSkuId: isProd ? 'sku_GN1ogVZOkA5gxv' : 'sku_E4Fj6ftjLgnE1G'      
    },
    // {
    //   type: 'combo2pax',
    //   id: 'combo2hoursPlusDrinks2pax',
    //   skuId: isProd ? 'sku_E5qPy27JPg0m8H' : 'sku_E4FitLXaqIPzYw',
    //   defaultName: 'Ski incl. drinks for 2 people',
    //   giftcardSkuId: isProd ? 'sku_E5qSVRNt6mjME9' : 'sku_E4Fj6ftjLgnE1G'      
    // },
    // {
    //   type: 'combo2pax',
    //   id: 'combo2hoursPlusWine2pax',
    //   skuId: isProd ? 'sku_E5qSwAxOBC9LNc' : 'sku_E5pnAB74D9s2TU',
    //   defaultName: 'Ski incl. wine for 2 people',
    //   giftcardSkuId: isProd ? 'sku_E5qUtC1988LBv6' : 'sku_E5pkRtcwLjfKjr'      
    // },
    // {
    //   type: 'combo2pax',
    //   id: 'combo2hoursPlusAfterski2pax',
    //   skuId: isProd ? 'sku_E5qQBFX8ZvTNZ1' : 'sku_E5pYm50F34pfNa',
    //   defaultName: 'Ski incl. afterski for 2 people',
    //   giftcardSkuId: isProd ? 'sku_E5qTg6xtph8mEb' : 'sku_E5pZJseweIPNj6'
    // },

    // Combos3pax
    {
      type: 'combo3pax',
      id: 'combo1hourInclEquip3pax',
      skuId: isProd ? 'sku_GN1pN2gAfHAuDp' : 'sku_E4Fj6ftjLgnE1G',
      defaultName: '',
      giftcardSkuId: isProd ? 'sku_GN1pN2gAfHAuDp' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'combo3pax',
      id: 'combo2hourInclEquip3pax',
      skuId: isProd ? 'sku_GN1pteTEE08Nve' : 'sku_E4Fj6ftjLgnE1G',
      defaultName: '',
      giftcardSkuId: isProd ? 'sku_GN1pteTEE08Nve' : 'sku_E4Fj6ftjLgnE1G'
    },
    {
      type: 'combo3pax',
      id: 'combo3hourInclEquip3pax',
      skuId: isProd ? 'sku_GN1pyK7pjzwoo1' : 'sku_E4Fj6ftjLgnE1G',
      defaultName: '',
      giftcardSkuId: isProd ? 'sku_GN1pyK7pjzwoo1' : 'sku_E4Fj6ftjLgnE1G'
    },
    // {
    //   type: 'combo3pax',
    //   id: 'combo2hoursPlusDrinks3pax',
    //   skuId: isProd ? 'sku_E5qQ97YrjdDFzI' : 'sku_E4GPJyfVKcEtDF',
    //   defaultName: 'Ski incl. drinks for 3 people',
    //   giftcardSkuId: isProd ? 'sku_E5qTBjzyfoE0j3' : 'sku_E4GOgKQPUCg0qu'
    // },
    // {
    //   type: 'combo3pax',
    //   id: 'combo2hoursPlusWine3pax',
    //   skuId: isProd ? 'sku_E5qST2AzCiryna' : 'sku_E5pn6RoPgeasEs',
    //   defaultName: 'Ski incl. wine for 3 people',
    //   giftcardSkuId: isProd ? 'sku_E5qUON0vyiXrRz' : 'sku_E5pkPUW6De3Ri6'
    // },
    // {
    //   type: 'combo3pax',
    //   id: 'combo2hoursPlusAfterski3pax',
    //   skuId: isProd ? 'sku_E5qRm2UR310gRk' : 'sku_E5pYDQxOkmAXdg',
    //   defaultName: 'Ski incl. afterski for 3 people',
    //   giftcardSkuId: isProd ? 'sku_E5qTCHt0Nyo6bC' : 'sku_E5pawFPfxBR2Qk'
    // },

    // Fixed amount giftcards
    {
      type: 'fixedAmount',
      id: 'fixedAmount100',
      skuId: isProd ? 'sku_GGgeooiauCRmdD' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGgeooiauCRmdD' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount200',
      skuId: isProd ? 'sku_GGgeVu4DrJn7C1' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGgeVu4DrJn7C1' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount300',
      skuId: isProd ? 'sku_GGgfuImoOH8Jb8' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGgfuImoOH8Jb8' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount400',
      skuId: isProd ? 'sku_GGgfiPejWdeZlT' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGgfiPejWdeZlT' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount500',
      skuId: isProd ? 'sku_GGgf7um8601pLV' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGgf7um8601pLV' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount600',
      skuId: isProd ? 'sku_GGgfUZZNVqZwLL' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGgfUZZNVqZwLL' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount800',
      skuId: isProd ? 'sku_GGgfYTehAp5qFZ' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGgfYTehAp5qFZ' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount1000',
      skuId: isProd ? 'sku_GGggbUT47cKxLW' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGggbUT47cKxLW' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount1200',
      skuId: isProd ? 'sku_GGggbJbaPcUnHO' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGggbJbaPcUnHO' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount1500',
      skuId: isProd ? 'sku_GGggCrEsWi72A6' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGggCrEsWi72A6' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount2000',
      skuId: isProd ? 'sku_GGgg9AD0uCIfHX' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGgg9AD0uCIfHX' : 'sku_GGnhiGh6OJF110'
    },
    {
      type: 'fixedAmount',
      id: 'fixedAmount2500',
      skuId: isProd ? 'sku_GGggRFNRPrimUN' : 'sku_GGnhiGh6OJF110',
      defaultName: 'Fixed amount',
      giftcardSkuId: isProd ? 'sku_GGggRFNRPrimUN' : 'sku_GGnhiGh6OJF110'
    },
  ]

}
export default products()